import { useTranslation } from "react-i18next"

import ComingSoon from "@/components/shared/ComingSoon"

export const ReportsComingSoon = () => {
  const { t } = useTranslation()
  return (
    <ComingSoon
      title={t("comingSoonRoutes.reports.title")}
      description={t("comingSoonRoutes.reports.description")}
      notifyMeButtonText={t("comingSoonRoutes.notifyMe")}
      // TODO: Add onNotifyMeButtonClick handler
    />
  )
}
